import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";

const INFO = {
  fleet: { plan: "Business", benefit: "Gérez votre flotte, la maintenance et les incidents en un seul endroit." },
  team: { plan: "Business", benefit: "Gérez votre équipe et ses opérations quotidiennes." },
  partners: { plan: "Business", benefit: "Suivez vos partenaires et leurs commissions automatiquement." },
  advanced_analytics: { plan: "Premium", benefit: "Analysez vos performances en profondeur, par établissement et consolidées." },
  multi_location: { plan: "Premium", benefit: "Pilotez plusieurs établissements avec la vue « Tous les établissements »." },
  exports: { plan: "Premium", benefit: "Exportez vos données (clients, réservations, finances) en CSV." },
};

export default function Upgrade() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const info = INFO[sp.get("feature")] || { plan: "Business", benefit: "Débloquez davantage de fonctionnalités ActiPilote." };
  return (
    <div className="flex min-h-[70vh] items-center justify-center p-6" data-testid="upgrade-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
          <Lock className="h-5 w-5 text-primary" />
        </div>
        <h1 className="text-xl font-bold text-slate-900" data-testid="upgrade-title">Disponible avec ActiPilote {info.plan}</h1>
        <p className="mt-2 text-sm text-slate-500">{info.benefit}</p>
        <a
          href="https://actipilote.com/pricing"
          target="_blank"
          rel="noreferrer"
          data-testid="upgrade-cta"
          className="mt-6 inline-block rounded-lg bg-primary px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
        >
          Découvrir l'offre
        </a>
        <button onClick={() => nav(-1)} className="mt-4 flex w-full items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-700">
          <ArrowLeft className="h-4 w-4" /> Retour
        </button>
      </div>
    </div>
  );
}
